<template>
    <div class="card chamber-search" >
        <div class="card-header">
            <h3 class="card-title py-1 my-0">
                {{translate('messages.last_session')}}
            </h3>
            <div class="card-tools">
                <button class="btn btn-default btn-sm" :class="$root.app_config.dark_mode ? 'white' : ''" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand fa-lg" style="vertical-align: middle;"></i></button>
            </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body" v-html="body">

        </div>
        <div v-if="loading" class="overlay dark">
            <i class="fas fa-sync fa-spin fa-2x"></i>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            body : '',
            loading : true,
            timer: null,
            monitoring: false
        }
    },
    methods: {
        loadChamberToday(){
            this.loading = true;
            axios.get('/api/chamberSearch/today').then(({ data }) => {
                this.body = data.data._source.body;
                this.loading = false;
            });
        },
        toggleMonitor(){
            this.monitoring = !this.monitoring;
            if(this.monitoring){
                this.timer = setInterval(function(){
                    this.loadChamberToday();
                }.bind(this), 60 * 1000);
            }else{
                clearInterval(this.timer);
            }
        }
    },
    mounted() {

    },
    created() {
        this.loadChamberToday();
    },
    beforeDestroy() {
        if(this.timer) clearInterval(this.timer);
    }
}
</script>